<template>
    <SidebarPanel
        :is-open="ui.settings.opened"
        :title="localizations[lang].settings"
        :peek-height="onlyMobileVisible ? '50vh' : null"
        side="right"
        persistent
        mobile-backdrop
        @close="toggleSettings"
    >
        <div class="flex flex-1 flex-col gap-0">
            <div class="border-t border-theme-border py-4 first:border-t-0 first:pt-0">
                <div class="flex items-baseline justify-between">
                    <span class="mb-3 block text-[13px] font-medium text-theme-text">{{
                        localizations[lang].tooltips.themeTitle
                    }}</span>
                    <span v-if="!isAudiobook" class="mb-3 block text-[13px] font-medium text-theme-text">{{
                        isPdf ? localizations[lang].zoomTitlePdf : localizations[lang].zoomTitle
                    }}</span>
                </div>
                <div class="flex items-center justify-between">
                    <ThemeIcon :show-title="false" />
                    <ComponentZoomControl v-if="!isAudiobook" />
                </div>
            </div>

            <ReadingModeSelector class="border-t border-theme-border py-4 first:border-t-0 first:pt-0" />

            <FontSelector
                v-if="showFontSelector"
                class="border-t border-theme-border py-4 first:border-t-0 first:pt-0"
            />

            <div
                v-if="showFontSelector"
                class="flex items-start justify-between border-t border-theme-border py-4 first:border-t-0 first:pt-0"
            >
                <LineSpacingSelector />
                <MarginsSelector />
            </div>

            <PageDisplay v-if="!isAudiobook" class="border-t border-theme-border py-4 first:border-t-0 first:pt-0" />

            <div
                v-if="onlyMobileVisible && showRangePaginator"
                class="border-t border-theme-border py-4 first:border-t-0 first:pt-0"
            >
                <span class="mb-3 block text-[13px] font-medium text-theme-text">{{
                    localizations[lang].tableOfContents
                }}</span>
                <ComponentRangePaginator />
                <ReadProgress class="mt-2" />
            </div>

            <ResetSettingsButton />
        </div>
    </SidebarPanel>
</template>

<script>
import { mapActions, mapGetters, mapState } from 'vuex';
import PageDisplay from './partials/PageDisplay.vue';
import FontSelector from './partials/FontSelector.vue';
import LineSpacingSelector from './partials/LineSpacingSelector.vue';
import MarginsSelector from './partials/MarginsSelector.vue';
import ComponentZoomControl from './../Components/ComponentZoomControl.vue';
import ComponentRangePaginator from './../Components/ComponentRangePaginator.vue';
import ReadProgress from './../Components/ReadProgress.vue';
import SidebarPanel from '../Components/SidebarPanel.vue';
import ThemeIcon from '../Components/ThemeIcon.vue';
import ReadingModeSelector from './partials/ReadingModeSelector.vue';
import ResetSettingsButton from './partials/ResetSettingsButton.vue';

export default {
    components: {
        PageDisplay,
        FontSelector,
        LineSpacingSelector,
        MarginsSelector,
        ComponentZoomControl,
        ComponentRangePaginator,
        ReadProgress,
        SidebarPanel,
        ThemeIcon,
        ReadingModeSelector,
        ResetSettingsButton,
    },
    computed: {
        ...mapState(['ui', 'device', 'localizations', 'lang', 'uiHidden', 'isFixedLayout']),
        ...mapGetters(['isPdf', 'onlyMobileVisible', 'isAudiobook', 'showRangePaginator', 'isEpub']),

        showFontSelector() {
            return this.isEpub && !this.isFixedLayout;
        },
    },
    methods: {
        ...mapActions(['toggleSettings']),
    },
};
</script>
